/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/KubernetesEndpointConstants" />
export const enum KubernetesEndpointAuthMethods {
    ServiceAccount = "ServiceAccount",
    Kubeconfig = "Kubeconfig",
    AzureSubscription = "AzureSubscription",
    AzureSubscriptionManual = "AzureSubscriptionManual"
}

export const enum SpnCreationMethod {
    Automatic = "Automatic",
    Manual = "Manual"
}

export const enum AzureSubscriptionAuthKeys {
    ActionCreatorKey = "azuresubscription-auth-actioncreator",
    ActionsKey = "azuresubscription-auth-actions",
    StoreKey = "azuresubscription-auth-store"
}

export const KubernetesEndpointEditorInstanceId = "kubernetes-endpoint-editor-instanceid";
export const AzureCloudUrl = "https://management.azure.com/";

export const ServerUrlCommand = "kubectl config view --minify -o jsonpath={.clusters[0].cluster.server}";
export const ServiceAccountCommand = "kubectl get serviceAccounts <service-account-name> -n <namespace> -o=jsonpath={.secrets[*].name}";
export const AccountCredsCommand = "kubectl get secret <service-account-secret-name> -n <namespace> -o json";
